import Box from "@untitled-ui/icons-react/build/esm/Box";
import Building07 from "@untitled-ui/icons-react/build/esm/Building07";
import Speedometer04 from "@untitled-ui/icons-react/build/esm/Speedometer04";
import Dataflow01 from "@untitled-ui/icons-react/build/esm/Dataflow01";
import UserSquare from "@untitled-ui/icons-react/build/esm/UserSquare";
import { ReactComponent as Shop1 } from "../assets/icons/shop-1.svg";
import { ReactComponent as Shirt } from "../assets/icons/tshirt-linear.svg";
import { ReactComponent as id } from "../assets/icons/id.svg";
import { hasNavigationAccess } from "../utils/onboardingHelper";

export const navigationBar = (path, navigations) => {
    const navigation = navigations?.navigationAccesses;

    const hasDashboardAccess = hasNavigationAccess(navigation, "dashboard", false);
    const hasSupplierOrdersAccess = hasNavigationAccess(navigation, "supplierOrders", false);
    const hasCustomerOrdersAccess = hasNavigationAccess(navigation, "customerOrders", false);
    const hasPricesAccess = hasNavigationAccess(navigation, "prices", false);
    const hasStockAccess = hasNavigationAccess(navigation, "stock", false);
    const hasProductsAccess = hasNavigationAccess(navigation, "products", false);
    const hasStoresAccess = hasNavigationAccess(navigation, "stores", false);
    const hasPOSAccess = hasNavigationAccess(navigation, "POS", false) || path.toLocaleLowerCase().startsWith("/pos");
    const hasCompaniesAccess = hasNavigationAccess(navigation, "companies", false);
    const hasOrganizationAccess = hasNavigationAccess(navigation, "organization", false);

    const createModeSupplierOrders = navigation?.supplierOrders?.createModeOnly;
    const createModeOnlyCustomerOrders = navigation?.customerOrders?.createModeOnly;
    const createModeOnlyPrices = navigation?.prices?.createModeOnly;
    const createModeOnlyStock = navigation?.stock?.createModeOnly;
    const createModeOnlyProducts = navigation?.products?.createModeOnly;
    const createModeOnlyStores = navigation?.stores?.createModeOnly;
    const createModeOnlyPOS = navigation?.POS?.createModeOnly;
    const createModeOnlyCompanies = navigation?.companies?.createModeOnly;
    const createModeOnlyOrganization = navigation?.organization?.createModeOnly;

    return [
        {
            to: "/dashboard",
            enabled: hasDashboardAccess,
            title: "Dashboard",
            iconSVG: Speedometer04,
            isActive: path.toLocaleLowerCase().startsWith("/dashboard")
        },
        {
            to: createModeSupplierOrders ? "/supplierOrders/create" : "/supplierOrders",
            enabled: hasSupplierOrdersAccess,
            title: "Supplier Orders",
            iconSVG: UserSquare,
            isActive: path.toLocaleLowerCase().startsWith("/supplierorders")
        },
        {
            to: createModeOnlyCustomerOrders ? "/customerOrders/create" : "/customerOrders",
            enabled: hasCustomerOrdersAccess,
            title: "Customer Orders",
            iconSVG: UserSquare,
            isActive: path.toLocaleLowerCase().startsWith("/customerorders")
        },
        {
            to: createModeOnlyPrices ? "/prices/create" : "/prices",
            enabled: hasPricesAccess,
            title: "Prices",
            iconSVG: Dataflow01,
            isActive: path.toLocaleLowerCase().startsWith("/prices")
        },
        {
            to: createModeOnlyStock ? "/stock/create" : "/stock",
            enabled: hasStockAccess,
            title: "Stock",
            iconSVG: Shirt,
            isActive: path.toLocaleLowerCase().startsWith("/stock")
        },
        {
            to: createModeOnlyProducts ? "/products/add" : "/products",
            enabled: hasProductsAccess,
            title: "Products",
            iconSVG: Shirt,
            isActive: path.toLocaleLowerCase().startsWith("/products")
        },
        {
            to: createModeOnlyStores ? "/stores/create" : "/stores",
            enabled: hasStoresAccess,
            title: "Stores",
            iconSVG: Shop1,
            isActive: path.toLocaleLowerCase().startsWith("/stores")
        },
        {
            to: createModeOnlyPOS ? "/pos/create" : "/pos",
            enabled: hasPOSAccess,
            title: "POS",
            iconSVG: Box,
            isActive: path.toLocaleLowerCase().startsWith("/pos")
        },
        {
            to: createModeOnlyCompanies ? "/companies/create" : "/companies",
            enabled: hasCompaniesAccess,
            title: "Companies",
            iconSVG: Building07,
            isActive: path.toLocaleLowerCase().startsWith("/companies")
        },
        {
            to: createModeOnlyOrganization ? "/account/create" : "/account",
            enabled: hasOrganizationAccess,
            title: "Account",
            iconSVG: id,
            isActive: path.toLocaleLowerCase().startsWith("/account")
        }
    ];
};
